import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 68ABC903-3D76-4C38-8165-4DB5F0353A20
 * name table-picnic
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-picnic.svg
 * tags
 */
export const TablePicnicIcon = createSvgIcon(<><path d="M4 6H20V9H18L18.22 11H23V13H18.44L19 18H16.5L15.94 13H8.06L7.5 18H5L5.56 13H1V11H5.78L6 9H4M15.5 9H8.5L8.29 11H15.71Z" /></>, 'TablePicnicIcon');
export default TablePicnicIcon